import { getApiBaseUrl } from '../../../utils/apiConfig';

const URL = () => `${getApiBaseUrl()}/api/pg-native/config/opening-recurrence`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` });

/** { nativeOperation, data: { windowDays, typeKeys } | null } */
export async function fetchOpeningRecurrence() {
  const res = await fetch(URL(), { headers: auth() });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || !j.success) throw new Error(j.message || 'Erro ao carregar a reincidência');
  return { nativeOperation: !!j.nativeOperation, data: j.data || null };
}

export async function saveOpeningRecurrence(windowDays, typeKeys) {
  const res = await fetch(URL(), {
    method: 'PUT',
    headers: { ...auth(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ windowDays, typeKeys }),
  });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || !j.success) throw new Error(j.message || 'Erro ao salvar a reincidência');
  return j.data;
}
